export default __webpack_public_path__ + "static/media/camera.feaa6e3e.svg";